export default {
    home: "Hogar",
    order: {
        submit: "Orden de revisión"
    },
    tunnel: {
        loginVerification: "Verificación de inicio de sesión",
        addressVerification: "Verificación de dirección"
    },
    catalog: "Catalogar",
    all: "Todo",
    return: {
        return: "Devolver"
    },
    errors: {
        404: "@:views.errors.404.title"
    },
    impersonation: "Orden en nombre de",
    approvals: "Aprobaciones",
    delegate: "Delegados",
    employees: "Mis empleados",
}